import React from "react";
import { LogoCarouselDemo } from "@/components/ui/code.demo";
import { FeaturesSectionWithHoverEffects } from "@/components/blocks/feature-section-with-hover-effects";
import { DashboardSection } from "@/components/blocks/dashboard-section";
import { EarlyAdopterSection } from "./early-adopter-section";
import { AboutSection } from "./about-section";
import { PainPointsSection } from "@/components/blocks/pain-points-section";

export const MainContentSection = () => {
  return (
    <section className="w-full bg-background">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="space-y-24 sm:space-y-28 md:space-y-36">
          <DashboardSection />
          <AboutSection />
          <LogoCarouselDemo />
          <PainPointsSection />
          <FeaturesSectionWithHoverEffects />
          <div className="pb-12 md:pb-16">
            <EarlyAdopterSection />
          </div>
        </div>
      </div>
    </section>
  );
};